export default "__VITE_ASSET__CXkdbhe2__"